package net.gorillagroove.notification

import com.squareup.sqldelight.ColumnAdapter
import kotlinx.serialization.Serializable
import net.gorillagroove.util.GGLog.logError
import kotlin.jvm.JvmInline

enum class UserNotificationType(internal val isPlaylistType: Boolean = false) {
    USER_RECOMMEND,
    SHARED_PLAYLIST_RENAME(isPlaylistType = true),
    SHARED_PLAYLIST_ACCESS(isPlaylistType = true),
    SHARED_PLAYLIST_TRACK_CHANGE(isPlaylistType = true),
    FAILED_DOWNLOAD,
    UNKNOWN
    ;

    fun toRawType() = RawUserNotificationType(this.name)
}

@Serializable
@JvmInline
value class RawUserNotificationType(val value: String) {
    fun asEnumeratedType(): UserNotificationType {
        return try {
            UserNotificationType.valueOf(value)
        } catch (e: Throwable) {
            this.logError("Unknown enumerated type value '$value' for enum '${UserNotificationType::class.simpleName}'")
            UserNotificationType.UNKNOWN
        }
    }
}

object RawUserNotificationTypeAdapter : ColumnAdapter<RawUserNotificationType, String> {
    override fun decode(databaseValue: String) = RawUserNotificationType(databaseValue)
    override fun encode(value: RawUserNotificationType) = value.value
}
